import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import * as React from 'react';
import SwipeableViews from 'react-swipeable-views';

import { INoticeMessage } from '../actions/login';
import i18n from '../resources/i18n';

const styles = (theme: Theme) =>
	createStyles({
		message: {
			backgroundColor: 'rgba(192,255,255,0.2)',
			color: 'white',
			minWidth: 275,
			overflowWrap: 'break-word',
			padding: theme.spacing(2),
			wordWrap: 'break-word',
		},
		stepper: {
			backgroundColor: 'transparent',
			color: 'white',
		},
		stepperButton: {
			color: 'white',
		},
		title: {
			fontSize: 14,
			marginBottom: theme.spacing(2),
		},
		view: {
			margin: theme.spacing(1),
		},
	});

export interface ILoginNoticeProps {
	messages: INoticeMessage[];
	interval: number;
}
export interface IProps
	extends React.Props<{}>,
		WithStyles<typeof styles>,
		ILoginNoticeProps {}
interface IState {
	activeStep: number;
}

/**
 * メッセージ表示用コンポーネント
 */
class LoginNotice extends React.Component<IProps, IState> {
	protected timer?: number;

	constructor(props: IProps) {
		super(props);

		this.state = {
			activeStep: 0,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidUpdate(prevProps: IProps) {
		if (prevProps !== this.props) {
			this.resetTimer();
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		if (this.timer !== undefined) {
			clearTimeout(this.timer);
		}
	}

	public render() {
		const { classes } = this.props;
		const activeStep = this.state.activeStep;
		const maxSteps = this.props.messages.length;

		return (
			<Paper className={classes.message}>
				<Typography className={classes.title} color="inherit">
					{i18n.t('LoginNotice_0001')}
				</Typography>
				<SwipeableViews
					index={activeStep}
					onChangeIndex={this.handleStepChange}
					enableMouseEvents={true}
				>
					{this.props.messages.map((message, ix) => (
						<div className={this.props.classes.view} key={ix}>
							<Typography color="inherit" variant="subtitle1">
								{message.startDate}
							</Typography>
							<Typography color="inherit" variant="h6">
								{message.titleList.map((title: string, i) => (
									<React.Fragment key={i}>
										<span
											dangerouslySetInnerHTML={{
												__html: title,
											}}
										/>
										<br />
									</React.Fragment>
								))}
							</Typography>
							{message.message.map((msg: string, i) => (
								<React.Fragment key={i}>
									<span
										key={`span-${i}`}
										dangerouslySetInnerHTML={{
											__html: msg,
										}}
									/>
									<br key={`br-${i}`} />
								</React.Fragment>
							))}
							{message.contact && (
								<Typography
									color="inherit"
									variant="body1"
									align="right"
								>
									{message.contact}
								</Typography>
							)}
						</div>
					))}
				</SwipeableViews>
				<MobileStepper
					steps={maxSteps}
					position="static"
					activeStep={activeStep}
					className={classes.stepper}
					nextButton={
						<Button
							size="small"
							onClick={this.handleNext}
							disabled={activeStep === maxSteps - 1}
							className={classes.stepperButton}
						>
							{i18n.t('LoginNotice_0002')}
							<KeyboardArrowRight />
						</Button>
					}
					backButton={
						<Button
							size="small"
							onClick={this.handleBack}
							disabled={activeStep === 0}
							className={classes.stepperButton}
						>
							<KeyboardArrowLeft />
							{i18n.t('LoginNotice_0003')}
						</Button>
					}
				/>
			</Paper>
		);
	}

	/**
	 * カルーセルの次へボタン押下処理
	 */
	protected handleNext = () => {
		this.setState(prevState => ({
			activeStep: prevState.activeStep + 1,
		}));
		this.resetTimer();
	};

	/**
	 * カルーセルの前へボタン押下処理
	 */
	protected handleBack = () => {
		this.setState(prevState => ({
			activeStep: prevState.activeStep - 1,
		}));
		this.resetTimer();
	};

	/**
	 * カルーセルの指定箇所押下処理
	 */
	protected handleStepChange = (activeStep: number) => {
		this.setState({ activeStep });
		this.resetTimer();
	};

	/**
	 * タイマ初期化
	 */
	protected resetTimer() {
		const interval = this.props.interval;
		if (!interval) {
			return;
		}

		if (this.props.messages.length === 0) {
			return;
		}

		if (this.timer !== undefined) {
			clearTimeout(this.timer);
		}

		// 一定時間ごとにメッセージを切り替える
		const timer = () => {
			const { activeStep } = this.state;
			this.timer = window.setTimeout(timer, interval);
			if (activeStep === this.props.messages.length - 1) {
				this.setState({ activeStep: 0 });
			} else {
				this.setState({
					activeStep: this.state.activeStep + 1,
				});
			}
		};
		this.timer = window.setTimeout(timer, interval);
	}
}

export default withStyles(styles)(LoginNotice) as React.ComponentType<
	ILoginNoticeProps
>;



// WEBPACK FOOTER //
// ./src/components/LoginNotice.tsx